// src/context/NotificationsContext.jsx
import React, { createContext, useContext, useEffect } from 'react';
import { useNotifications } from '../features/notifications/hooks/useNotifications';
import { useAuth } from './AuthContext';

const NotificationsContext = createContext();

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotificationsContext must be used within a NotificationsProvider');
  }
  return context;
};

export const NotificationsProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const notificationsData = useNotifications();

  // Handle polling automatically based on authentication
  useEffect(() => {
    console.log("NotificationsProvider: Auth state changed", { 
      isAuthenticated,
      isPolling: notificationsData.isPolling 
    });
    
    if (isAuthenticated) {
      console.log("NotificationsProvider: Starting polling");
      setTimeout(() => {
        notificationsData.startPolling();
      }, 1500);
    }
    // Note: stopPolling is handled automatically by the session manager when auth changes
  }, [isAuthenticated, notificationsData.startPolling]);

  return (
    <NotificationsContext.Provider value={notificationsData}>
      {children}
    </NotificationsContext.Provider>
  );
};